/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { createContext, useContext } from 'react';

interface ServerSideRuntime {
	origin?: string;
}

export const EMPTY_SERVER_SIDE_RUNTIME = {} as ServerSideRuntime;
export const ServerSideRuntimeContext = createContext<ServerSideRuntime>(EMPTY_SERVER_SIDE_RUNTIME);
export const ServerSideRuntimeProvider = ServerSideRuntimeContext.Provider;

export const useServerSideRuntime = () => {
	const runtime = useContext(ServerSideRuntimeContext);

	if (!runtime) {
		throw new Error('ServerSideRuntimeContext is not set');
	}

	return runtime;
};
